export const isMailFormatValue = (value) => {
  return (/^[\w().-]+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(value));
};